export default __webpack_public_path__ + "7ae5957.png";